export default function useCurrencyFormatter(value: number, maxDecimal?: number, minDecimal?: number) {
  const formatter = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: "GBP",
    maximumFractionDigits: maxDecimal ?? 0,
    minimumFractionDigits: minDecimal ?? 0
  });

  return formatter.format(value);
}
